module.exports = __webpack_public_path__ + "img/emerald_logo.bb7890b7.png";